import React from 'react';
import TabView from '../TabView';

import './SecondaryTabView.scss';

const SecondaryTabView = props => <TabView { ...props } className='SecondaryTabView' labelClassName='subtitle'/>;

export default SecondaryTabView;
